<template>
  <b-card>
    <div class="col-sm-12">
      <h4 class="h4-title">{{text.unit}}</h4>
      <b-row v-if="projectName">
        <b-col class="form-group" cols="4">
          <h5>{{text.unit}}</h5>
          <h5>{{projectName}}</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          class="form-group"
          cols="4"
        >
          <label for="formGroupExampleInput">{{text.unitNumber}}</label>
          <input
            type="text"
            class="form-control"
            id="unitNumber"
            :placeholder="text.unitNumber"
            v-model="Unit.unitNumber"
          >
        </b-col>
        <b-col
          class="form-group"
          cols="4"
        >
          <label for="formGroupExampleInput">{{text.gateway}}</label>
          <input
            type="text"
            class="form-control"
            id="gateway"
            :placeholder="text.gateway"
            v-model="Unit.gateway"
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col
          class="form-group"
          cols="4"
        >
         <label for="formGroupExampleInput">{{text.port1}}</label>
          <input
            type="text"
            class="form-control"
            id="port1"
            :placeholder="text.port1"
            v-model="Unit.port1"
          >
        </b-col>
        <b-col
          class="form-group"
          cols="4"
        >
         <label for="formGroupExampleInput">{{text.port2}}</label>
          <input
            type="text"
            class="form-control"
            id="port2"
            :placeholder="text.port2"
            v-model="Unit.port2"
          >
        </b-col>
      </b-row>
      <b-row>

            <div class="col-lg-12">
              <b-alert
                variant="success"
                dismissible
                fade
                :show="saveDone"
              >
                {{successMessage}}
              </b-alert>
              <b-alert
                variant="danger"
                dismissible
                fade
                :show="saveError"
              >
                {{errorMessage}}
              </b-alert>
            </div>

      </b-row>
      <b-row>
        <b-col
          class="form-group"
          cols="2"
        >
          <button
            type="button"
            class="btn action-b-btn b-btn" @click="saveUnit"
          >{{!editMode ? text.add : text.update}}</button>
        </b-col>
        <b-col class="form-group" cols="2" v-if="!editMode">
          <button
            type="button"
            class="btn btn-back b-btn"
            @click="backToProfile"
          >{{text.back}}</button>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import MqdcOneClient from '@/models/mqdc-one-client';
import { textUserProfiles } from '@/assets/utils/language';
export default {
  name: 'Unit',
  props: ['id', 'projectcode', 'unitProp'],
  data () {
    return {
      Unit: {
        unitNumber: '',
        gateway: '',
        port1: '',
        port2: ''
      },
      saveDone: false,
      saveError: false,
      editMode: false,
      projectName: '',
      successMessage: '',
      errorMessage: '',
      mqdcOneClient: {},
      text: {}
    };
  },
  created: function () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    document.title = 'One App: User Profile: Unit';
    this.setEditUnit();
  },
  methods: {
    saveUnit () {
      if (!this.Unit.unitNumber) {
        this.saveError = true;
        this.errorMessage = 'Please enter unit information to save.';
        return false;
      }
      const unit = {
        'unitNumber': this.Unit.unitNumber,
        'gateway': this.Unit.gateway,
        'port1': this.Unit.port1,
        'port2': this.Unit.port2
      };
      if (!this.editMode) {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects/${this.projectcode}/units`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.post(
              url, unit).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              this.setDefaultUnitForm();
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error.response.data);
              });
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects/${this.projectcode}/units/${this.unitProp.id}`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.patch(
              url, unit).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              location.reload();
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error.response.data);
              });
          });
        } catch (err) {
          console.log('Error : ', err);
        }
      }
    },
    setEditUnit () {
      if (this.unitProp) {
        this.editMode = true;
        this.saveBtnCaption = this.text.update;
        this.Unit = {
          unitNumber: this.unitProp.unitNumber,
          gateway: this.unitProp.gateway,
          port1: this.unitProp.port1,
          port2: this.unitProp.port2
        };
      } else {
        this.projectName = sessionStorage.getItem('projectname');
      }
    },
    setDefaultUnitForm () {
      this.Unit = {
        unitNumber: '',
        gateway: '',
        port1: '',
        port2: ''
      };
    },
    backToProfile () {
      this.$router.push({ name: 'one_app_profiles-profile', params: { id: this.id } });
    }
  },
  watch: {
    $language: function () {
      this.text = textUserProfiles(this.$language);
    }
  },
  mounted () {
    this.text = textUserProfiles(this.$language);
  }
};
</script>
<style scoped src="@/assets/css/projectunit.css"></style>
